import { RefObject } from 'react';

type IPlaceCursorComponents = HTMLIonInputElement | HTMLIonTextareaElement | HTMLIonSearchbarElement;

// place at the end of the text, unless a location is passed in
export const usePlaceCursor = () => {
    return (ref: RefObject<IPlaceCursorComponents>, focusLocation?: number, append?: boolean) => {
        setTimeout(async () => {
            const inputEl = await ref.current!.getInputElement();
            ref.current!.setFocus();
            inputEl.setSelectionRange(
                focusLocation || inputEl.value.length,
                focusLocation || inputEl.value.length
            );

            // if appending or there's not a location for the cursor passed in, scroll to bottom
            inputEl.scrollTo({top: !append && focusLocation ? 0 : inputEl.scrollHeight});
        }, 300);
    };
};
